/** Chaves das abas fixas na ficha da mudança (espelha o backend). */

export const CHANGE_DETAIL_FIXED_TAB_KEYS = [
  'subtasks',
  'approvals',
  'transport',
  'attachments',
  'assistant',
] as const;

export type ChangeDetailFixedTabKey = (typeof CHANGE_DETAIL_FIXED_TAB_KEYS)[number];

export const DEFAULT_CHANGE_DETAIL_PAGE_TAB_ORDER: string[] = [
  'subtasks',
  'approvals',
  'transport',
  'attachments',
  'assistant',
];

export function isCustomDetailTabKey(key: string): boolean {
  return key.startsWith('detail-tab-');
}

export function customDetailTabIdFromKey(key: string): number | null {
  if (!isCustomDetailTabKey(key)) return null;
  const suffix = key.slice('detail-tab-'.length);
  const id = Number(suffix);
  return Number.isFinite(id) && id > 0 ? id : null;
}

export function normalizePageTabOrder(order: string[] | undefined | null): string[] {
  const source = order?.length ? order : DEFAULT_CHANGE_DETAIL_PAGE_TAB_ORDER;
  const seen = new Set<string>();
  const merged: string[] = [];
  for (const raw of source) {
    const key = String(raw).trim();
    if (!key || seen.has(key)) continue;
    merged.push(key);
    seen.add(key);
  }
  for (const fixed of DEFAULT_CHANGE_DETAIL_PAGE_TAB_ORDER) {
    if (!seen.has(fixed)) {
      merged.push(fixed);
      seen.add(fixed);
    }
  }
  return merged;
}

/** Oculta Transporte quando a aba não se aplica nesta mudança/status. */
export function visiblePageTabOrder(
  order: string[],
  options: { showTransportTab: boolean },
): string[] {
  return order.filter((key) => {
    if (key === 'transport') return options.showTransportTab;
    return true;
  });
}
